import { render, staticRenderFns } from "./contradictory.vue?vue&type=template&id=0b22b1ca&scoped=true&"
import script from "./contradictory.vue?vue&type=script&lang=js&"
export * from "./contradictory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b22b1ca",
  null
  
)

export default component.exports